const CAPITALIZATION_FIELDS = ['quarter1', 'quarter2', 'quarter3', 'quarter4']

function addChanged(changed, code, field) {
  if (code != null && code !== '' && field) {
    changed.add(`${code}:${field}`)
  }
}

function processCapitalizationRow(changed, row) {
  if (!row?.code) return

  if (Array.isArray(row.changedFields)) {
    for (const field of row.changedFields) {
      addChanged(changed, row.code, field)
    }
    return
  }

  for (const field of CAPITALIZATION_FIELDS) {
    if (row[field] === true) {
      addChanged(changed, row.code, field)
    }
  }
}

function processBudgetRow(changed, row) {
  if (!row?.code) return

  if (Array.isArray(row.changedFields)) {
    if (row.changedFields.includes('value')) {
      addChanged(changed, row.code, 'value')
    }
    return
  }

  if (row.value === true) {
    addChanged(changed, row.code, 'value')
  }
}

export function normalizeVersionDifferences(data) {
  const changed = new Set()
  if (!data) return changed

  const capitalizationCodeDifferences = data.capitalizationCodeDifferences ?? []
  if (Array.isArray(capitalizationCodeDifferences)) {
    for (const item of capitalizationCodeDifferences) {
      if (item?.code && item?.quarter) {
        addChanged(changed, item.code, item.quarter)
      }
    }
  }

  const budgetCodeDifferences = data.budgetCodeDifferences ?? []
  if (Array.isArray(budgetCodeDifferences)) {
    for (const item of budgetCodeDifferences) {
      if (!item?.code) continue
      const field = item.field ?? item.quarter ?? 'value'
      addChanged(changed, item.code, field)
    }
  }

  const capitalizationRows = data.capitalizationRows
    ?? data.capitalization?.rows
    ?? data.capitalization
    ?? []
  if (Array.isArray(capitalizationRows)) {
    for (const row of capitalizationRows) {
      processCapitalizationRow(changed, row)
    }
  }

  const budgetRows = data.budgetRows
    ?? data.budget?.rows
    ?? data.budget
    ?? []
  if (Array.isArray(budgetRows)) {
    for (const row of budgetRows) {
      processBudgetRow(changed, row)
    }
  }

  return changed
}

export function isVersionFieldChanged(changedFields, code, field) {
  if (!code) return false
  return changedFields.has(`${code}:${field}`)
}

export function isAnyVersionFieldChanged(changedFields, field) {
  if (!field || !changedFields?.size) return false
  const suffix = `:${field}`
  for (const key of changedFields) {
    if (key.endsWith(suffix)) return true
  }
  return false
}

export function isVersionTotalFieldChanged(changedFields, code, field) {
  if (!field) return false
  return isVersionFieldChanged(changedFields, code, field)
    || isAnyVersionFieldChanged(changedFields, field)
}
